import { RAW, ENRICHED } from './constants'

export const isDisabled = (
  formItemIsRaw: boolean,
  dataView: string,
  showRaw: boolean
): boolean => {
  if (formItemIsRaw && showRaw && dataView === ENRICHED) {
    return true
  }
  return false
}

export const isHidden = (
  formItemIsRaw: boolean,
  dataView: string,
  showRaw: boolean
): boolean => {
  if (
    (formItemIsRaw && dataView === RAW) ||
    (!formItemIsRaw && dataView === ENRICHED) ||
    (formItemIsRaw && showRaw && dataView === ENRICHED)
  ) {
    return false
  }
  return true
}

//Extended product group list is more than 20 items
export const isExtendedPGList = (
  referenceProductGroups: Array<any> | null | undefined
): boolean => {
  return (
    Array.isArray(referenceProductGroups) && referenceProductGroups.length > 20
  )
}
